import React, { useState } from 'react'
import ReactTable from 'react-table'
import moment from 'moment'
import { Query } from 'react-apollo'
import { useMutation, useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import FileDownload from 'js-file-download'
import axios from 'axios'
import {
  Modal,
  Radio,
  DatePicker,
  message,
  Tooltip,
} from 'antd'
import {
  Div, H3, Button, Loading, P, DynamicButtonLink,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'
import {
  Wrapper, InputWithPlaceHolder, StatusSelector, ActionSelector, HeaderLabel, CellText,
} from '../../../components/driver-components'
import { DRIVER_LIST } from '../../../constants/graphql/query'
import { SYNC_DRIVER_SALARY } from '../../../constants/graphql/mutation'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import { monthConverter } from '../../../utils/util-services'
import './style-css.css'
import PERMISSION from '../../../constants/permissions'
import { status, statusText } from '../constants'

const { color } = theme

export const colorSelector = (e) => {
  switch (e) {
    case status.OLD:
      return color.error
    case status.LEAVE:
      return color.error
    case status.LICENSE_EXPIRED:
      return color.warning
    case status.NEWS:
      return color.success
    default:
      return color.charcoalGrey
  }
}

export const textStatusSelector = (e) => {
  switch (e) {
    case status.OLD:
      return statusText.OLD
    case status.LEAVE:
      return statusText.LEAVE
    case status.LICENSE_EXPIRED:
      return statusText.LICENSE_EXPIRED
    case status.NEWS:
      return statusText.NEWS
    default:
      return 'ไม่ระบุ'
  }
}

const download = (setIsLoading) => {
  axios({
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    url: `${getURL().FILE_SERVER}/download/drivers`,
  }).then((resp) => {
    FileDownload(resp.data, `ข้อมูลพนักงานขับรถ วันที่ ${moment().format('DD')} ${monthConverter(moment().format('MM'))} ${parseInt(moment().format('YYYY'), 10) + 543}.xls`)
    setIsLoading([false, false])
  })
}

const downloadAllowance = (date, text, month, bank, bankText, setIsLoading) => {
  axios({
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    url: `${getURL().FILE_SERVER}/download/drivercompensation?start=${moment(date[0]).format('YYYY-MM-DD')}&end=${moment(date[1]).format('YYYY-MM-DD')}&bankType=${bank}`,
  }).then((resp) => {
    FileDownload(resp.data, `เบี้ยเลี้ยงพนักงานขับรถ ${monthConverter((moment(month).format('MM')).toString())} ${text} ${bankText}.xlsx`)
    setIsLoading([false, false])
  })
}

const downloadFleetAllowance = (date, text, month, setIsLoading) => {
  axios({
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    url: `${getURL().FILE_SERVER}/download/superuser/report/driver?startDate=${moment(date[0]).format('YYYY-MM-DD')}&endDate=${moment(date[1]).format('YYYY-MM-DD')}`,
  }).then((resp) => {
    FileDownload(resp.data, `รายงานเบี้ยเลี้ยงตามFleet ${monthConverter((moment(month).format('MM')).toString())} ${text}.xlsx`)
    setIsLoading(false)
  })
}

const downloadEstimateFleetAllowance = (date, text, month, setIsLoading) => {
  axios({
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    url: `${getURL().FILE_SERVER}/download/superuser/report/driver-allstatus?startDate=${moment(date[0]).format('YYYY-MM-DD')}&endDate=${moment(date[1]).format('YYYY-MM-DD')}`,
  }).then((resp) => {
    FileDownload(resp.data, `รายงานเบี้ยเลี้ยงประมานการตามFleet ${monthConverter((moment(month).format('MM')).toString())} ${text}.xlsx`)
    setIsLoading(false)
  })
}

const downloadSalary = (setSalaryLoading) => {
  axios({
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    url: `${getURL().FILE_SERVER}/download/excel/driver/salary`,
  }).then((resp) => {
    FileDownload(resp.data, `รายงานเงินเดือนพนักงานขับรถ ณ วันที่ ${moment().format('YYYY-MM-DD')}.xlsx`)
    setSalaryLoading(false)
  })
}

const AllowanceModal = ({
  modal, setModal, isLoading, setIsLoading,
}) => {
  const [month, setMonth] = useState()
  const [date, setDate] = useState([])
  const [text, setText] = useState([])
  const [radio, setRadio] = useState()
  const [bank, setBank] = useState('0')
  const [bankText, setBankText] = useState([])
  return (
    <Modal
      title="เลือกวันที่เริ่ม-สิ้นสุด"
      visible={modal}
      onCancel={() => setModal(false)}
      onOk={() => {
        setIsLoading([false, true])
        downloadAllowance(date, text, month, bank, bankText, setIsLoading)
      }}
      okButtonProps={{
        disabled: date.length < 2 || isLoading[1],
        loading: isLoading[1],
      }}
      cancelButtonProps={{
        disabled: isLoading[1],
      }}
    >
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='column'>
        <DatePicker.MonthPicker placeholder='เลือกเดือน' onChange={(e) => {
          setMonth(e)
          setRadio()
          setDate([])
        }} style={{ width: '100%' }} />
        <Radio.Group style={{ width: 'fit-content', margin: '16px 0' }} onChange={(e) => {
          setRadio(e.target.value)
          switch (e.target.value) {
            case 'month':
              setDate([moment(month).startOf('month'), moment(month).add('months', 1).date(0)])
              setText('ทั้งเดือน')
              break
            case 'first':
              setDate([moment(month).startOf('month'), moment(`${month.format('Y')}-${month.format('M')}-10`)])
              setText('วันที่ 1-10')
              break
            case 'middle':
              setDate([moment(`${month.format('Y')}-${month.format('M')}-11`), moment(`${month.format('Y')}-${month.format('M')}-20`)])
              setText('วันที่ 11-20')
              break
            case 'last':
              setDate([moment(`${month.format('Y')}-${month.format('M')}-21`), moment(month).add('months', 1).date(0)])
              setText('วันที่ 21-สิ้นเดือน')
              break
            default:
              setDate(undefined)
              break
          }
        }} disabled={_.isUndefined(month)} value={radio}>
          <Radio.Button value='month'>ทั้งเดือน</Radio.Button>
          <Radio.Button value='first'>วันที่ 1-10</Radio.Button>
          <Radio.Button value='middle'>วันที่ 11-20</Radio.Button>
          <Radio.Button value='last'>วันที่ 21-สิ้นเดือน</Radio.Button>
        </Radio.Group>
        <Radio.Group style={{ width: 'fit-content', margin: '16px 0' }} onChange={(e) => {
          switch (e.target.value) {
            case '1':
              setBank('1')
              setBankText('ธนาคาร แลนด์ แอนด์ เฮ้าส์')
              break
            case '2':
              setBank('2')
              setBankText('ธนาคาร ไทยพาณิชย์')
              break
            default:
              setBank('0')
              setBankText('ทุกธนาคาร')
              break
          }
        }} value={bank}>
          <Radio.Button value='0'>ทั้งหมด</Radio.Button>
          <Radio.Button value='1'>LH BANK</Radio.Button>
          <Radio.Button value='2'>SCB</Radio.Button>
        </Radio.Group>
      </Div>
    </Modal>
  )
}

const FleetAllowanceModal = ({
  fleetModal, setFleetModal, isLoading, setIsLoading,
}) => {
  const [month, setMonth] = useState()
  const [date, setDate] = useState([])
  const [text, setText] = useState([])
  const [radio, setRadio] = useState()
  const [type, setType] = useState(0)
  return (
    <Modal
      title="เลือกวันที่เริ่ม-สิ้นสุด"
      visible={fleetModal}
      onCancel={() => {
        setFleetModal(false)
        setDate([])
        setText([])
        setMonth()
        setRadio()
        setType(0)
      }}
      onOk={() => {
        setIsLoading(true)
        if (type) downloadEstimateFleetAllowance(date, text, month, setIsLoading)
        else downloadFleetAllowance(date, text, month, setIsLoading)
        setDate([])
        setText([])
        setMonth()
        setRadio()
        setType(0)
      }}
      destroyOnClose={true}
      okButtonProps={{
        disabled: date.length < 2 || isLoading,
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='column'>
        <Radio.Group style={{ width: 'fit-content', margin: '0 0 16px 0' }} onChange={(e) => {
          setType(e.target.value)
        }} value={type}>
          <Radio.Button value={0}>เบี้ยเลี้ยงตามจริง</Radio.Button>
          <Radio.Button value={1}>เบี้ยเลี้ยงประมาณการ</Radio.Button>
        </Radio.Group>
        <DatePicker.MonthPicker placeholder='เลือกเดือน' onChange={(e) => {
          setMonth(e)
          setRadio()
          setDate([])
        }} style={{ width: '100%' }} />
        <Radio.Group style={{ width: 'fit-content', margin: '16px 0' }} onChange={(e) => {
          setRadio(e.target.value)
          switch (e.target.value) {
            case 'month':
              setDate([moment(month).startOf('month'), moment(month).add('months', 1).date(0)])
              setText('ทั้งเดือน')
              break
            case 'first':
              setDate([moment(month).startOf('month'), moment(`${month.format('Y')}-${month.format('M')}-10`)])
              setText('วันที่ 1-10')
              break
            case 'middle':
              setDate([moment(`${month.format('Y')}-${month.format('M')}-11`), moment(`${month.format('Y')}-${month.format('M')}-20`)])
              setText('วันที่ 11-20')
              break
            case 'last':
              setDate([moment(`${month.format('Y')}-${month.format('M')}-21`), moment(month).add('months', 1).date(0)])
              setText('วันที่ 21-สิ้นเดือน')
              break
            default:
              setDate(undefined)
              break
          }
        }} disabled={_.isUndefined(month)} value={radio}>
          <Radio.Button value='month'>ทั้งเดือน</Radio.Button>
          <Radio.Button value='first'>วันที่ 1-10</Radio.Button>
          <Radio.Button value='middle'>วันที่ 11-20</Radio.Button>
          <Radio.Button value='last'>วันที่ 21-สิ้นเดือน</Radio.Button>
        </Radio.Group>
      </Div>
    </Modal>
  )
}

const ExportSalaryModal = ({
  exportSalaryModal, setExportSalaryModal, isLoading, setIsLoading,
}) => {
  const [month, setMonth] = useState()
  return (
    <Modal
      title="เลือกวันที่เริ่ม-สิ้นสุด"
      visible={exportSalaryModal}
      onCancel={() => {
        setExportSalaryModal(false)
        setMonth()
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/driver/salary?selectedDate=${moment(month).startOf('month').format('YYYY-MM-DD')}`,
        }).then((resp) => {
          FileDownload(resp.data, `รายงานเงินเดือนพนักงานขับรถ เดือน ${moment(month).format('MMMM YYYY')}.xlsx`)
          setIsLoading(false)
          setMonth()
        })
      }}
      destroyOnClose={true}
      okButtonProps={{
        disabled: _.isUndefined(month) || isLoading,
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Div display='flex' justifyContent='space-between' alignItems='center' flexDirection='column'>
        <DatePicker.MonthPicker placeholder='เลือกเดือน' onChange={(e) => {
          setMonth(e)
        }} style={{ width: '100%' }} />
      </Div>
    </Modal>
  )
}

const SyncModal = ({
  syncModal, setSyncModal,
}) => {
  const [month, setMonth] = useState()
  const [doAction, { loading }] = useMutation(SYNC_DRIVER_SALARY)
  return (
    <Modal
      title="เลือกเดือน"
      visible={syncModal}
      destroyOnClose={true}
      onCancel={() => {
        setSyncModal(false)
        setMonth()
      }}
      onOk={() => {
        doAction({
          variables: { month },
        }).then(({ data }) => {
          const resp = data.SyncDriverSalary
          if (resp.success) {
            message.success(resp.message)
            setMonth()
            setSyncModal(false)
          } else message.error(resp.message)
        })
      }}
      okButtonProps={{
        disabled: loading || _.isUndefined(month),
        loading,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      <Div alignItems='center' display='flex' flexDirection='row' justifyContent='space-between'>
        <P margin = '0 32px 0 0'>เลือกเดือน</P>
        <DatePicker.MonthPicker
          format='MM/YYYY'
          onChange={(e) => {
            setMonth(e)
          }}
        />
      </Div>
    </Modal>
  )
}

const Index = () => {
  const [modal, setModal] = useState(false)
  const [fleetModal, setFleetModal] = useState(false)
  const [exportSalaryModal, setExportSalaryModal] = useState(false)
  const [isLoading, setIsLoading] = useState([false, false])
  const [fleetLoading, setFleetLoading] = useState(false)
  const [syncModal, setSyncModal] = useState(false)
  const [exportSalaryLoading, setExportSalaryLoading] = useState(false)
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการพนักงานขับรถ</H3>
        <Div display='flex' flexDirection='row' justifyContent='space-between'>
          <Button
            inverse
            loading={isLoading[0]}
            disabled={!_.includes(window.perms, PERMISSION.EXPORT_DRIVER) || isLoading[0]}
            text='Export'
            onClick={() => {
              setIsLoading([true, false])
              download(setIsLoading)
            }}
            margin='0 16px 0 0'
          />
          <Button
            text='บันทึกเงินเดือนในPEAK'
            onClick={() => {
              setSyncModal(true)
            }}
            margin='0 16px 0 0'
          />
          <Button
            text='พิมพ์รายงานเงินเดือน'
            icon='fas fa-print'
            disabled={exportSalaryLoading}
            onClick={() => {
              setExportSalaryModal(true)
            }}
            margin='0 16px 0 0'
          />
          <Button
            text='พิมพ์รายงานเบี้ยเลี้ยงตามFleet'
            icon='fas fa-print'
            onClick={() => {
              setFleetModal(true)
            }}
            margin='0 16px 0 0'
          />
          <Button
            text='พิมพ์เบี้ยเลี้ยงพนักงาน'
            icon='fas fa-print'
            onClick={() => {
              setModal(true)
            }}
            margin='0 16px 0 0'
          />
          <DynamicButtonLink link='/driver/add' condition={_.includes(window.perms, PERMISSION.CREATE_DRIVER)} props={{ text: 'เพิ่มคนขับรถ' }} />
        </Div>
      </Div>
      <List />
      <AllowanceModal modal={modal} setModal={setModal} isLoading={isLoading} setIsLoading={setIsLoading} />
      <SyncModal syncModal={syncModal} setSyncModal={setSyncModal}/>
      <FleetAllowanceModal fleetModal={fleetModal} setFleetModal={setFleetModal} isLoading={fleetLoading} setIsLoading={setFleetLoading} />
      <ExportSalaryModal exportSalaryModal={exportSalaryModal} setExportSalaryModal={setExportSalaryModal} isLoading={exportSalaryLoading} setIsLoading={setExportSalaryLoading} />
    </Div>
  )
}

export const List = () => {
  const [filtered, setFiltered] = useState({ status: 'NEW' })
  const [sorted, setSorted] = useState([{ id: 'id', desc: false }])
  const [current, setCurrent] = useState(0)
  const {
    data, loading, error, refetch,
  } = useQuery(DRIVER_LIST, {
    variables: {
      limit: 5,
      offset: current * 5,
      orderBy: sorted[0].desc ? 'DESC' : 'ASC',
      orderField: sorted[0].id,
      ...filtered,
    },
  })

  const columns = [
    {
      Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ชื่อ - นามสกุล
        </HeaderLabel>
      </Div>
      ),
      accessor: 'fullname',
      Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
      Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
      filterMethod: (filter, row) => _.includes(row.fullname, filter.value),
      sortable: false,
      filterable: true,
      width: 200,
    },
    {
      Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เบี้ยเลี้ยง
        </HeaderLabel>
      </Div>
      ),
      accessor: 'compensation',
      sortable: false,
      filterable: false,
      Cell: props => <CellText>{props.value}</CellText>,
      Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
      filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
      width: 100,
    }, {
      Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ตั๋วน้ำมัน
        </HeaderLabel>
      </Div>
      ),
      accessor: 'remainTickets',
      sortable: false,
      filterable: false,
      Cell: props => <CellText>{props.value}</CellText>,
      Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
      filterMethod: (filter, row) => _.includes(row.remainTickets, filter.value),
      width: 100,
    }, {
      Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          รอเบิก
        </HeaderLabel>
      </Div>
      ),
      accessor: 'remainFuel',
      sortable: false,
      filterable: false,
      Cell: props => <CellText>{props.value}</CellText>,
      Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
      filterMethod: (filter, row) => _.includes(row.remainFuel, filter.value),
      width: 100,
    }, {
      Header: <HeaderLabel>สถานะ</HeaderLabel>,
      accessor: 'status',
      sortable: false,
      filterable: true,
      Cell: props => <P color={colorSelector(props.original.isLeave ? status.LEAVE : props.value)}>{textStatusSelector(props.original.isLeave ? status.LEAVE : props.value)}</P>,
      filterMethod: (filter, row) => filter.value === row.status || filter.value === 'ALL',
      Filter: ({ onChange }) => <StatusSelector key='filter' statusAttr='ทั้งหมด' handleChange={e => onChange(e)} filter={true} />,
      width: 140,
    }, {
      Header: null,
      accessor: 'action',
      sortable: false,
      filterable: false,
      Cell: props => <ActionSelector props={{ ...props, refetch }} />,
      width: 150,
    }]

    if (loading && _.isEmpty(data)) return <Loading center='true' />
    if (error) return <P>เกิดข้อผิดพลาด</P>
    return (
      <Wrapper overflow padding='0 0 40px 0'>
        <Div>
          <ReactTable
            className='table'
            data={data.DriverList.lists} // *
            resizable={false}
            columns={columns} // *
            minRows={5}
            manual
            refetch={refetch}
            // defaultPageSize={10}
            showPageSizeOptions={false}
            getTdProps={() => ({ disabled: true })} // *
            getTrProps={(state, rowInfo) => { // *
              if (rowInfo) {
                return {
                  style: {
                    padding: '8px 0',
                    backgroundColor: '#ffffff',
                    borderLeft: `3px solid ${color.primaryColor}`,
                  },
                }
              } return {}
            }}
            previousText='ก่อนหน้า'
            nextText='ถัดไป'
            pageText='หน้า'
            ofText='จาก'
            noDataText='ไม่พบข้อมูล'
            page={current}
            pages={Math.ceil(data.DriverList.totalFilter / 5)}
            onPageChange={page => setCurrent(page)}
            onFilteredChange={async (newFiltered) => {
              const newOjb = {}
              await newFiltered.forEach((v) => {
                if (v.id === 'id' || v.id === 'employeeId' || v.id === 'compensation' || v.id === 'remainTickets' || v.id === 'remainFuel') {
                  Object.assign(newOjb, { [v.id]: parseInt(v.value, 10) })
                } else { Object.assign(newOjb, { [v.id]: v.value }) }
              })
              setFiltered(newOjb)
              setCurrent(0)
            }}
            onSortedChange={async (newSorted) => {
              setSorted(newSorted)
              setCurrent(0)
            }}
          />
          {
            loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
          }
        </Div>
      </Wrapper>
    )
}
export default Index
